import { apiClient } from "@/lib/apiClient";

/** RUN module service — Tasks, Calendar, Documents. Single place the UI talks to these APIs. */
export const runService = {
  // Tasks
  async listTasks(params = {}) {
    const { data } = await apiClient.get("/tasks", { params });
    return data;
  },
  async taskSummary() {
    const { data } = await apiClient.get("/tasks/summary");
    return data;
  },
  async createTask(payload) {
    const { data } = await apiClient.post("/tasks", payload);
    return data.task;
  },
  async updateTask(id, payload) {
    const { data } = await apiClient.put(`/tasks/${id}`, payload);
    return data.task;
  },
  async completeTask(id) {
    const { data } = await apiClient.post(`/tasks/${id}/complete`);
    return data.task;
  },
  async cancelTask(id) {
    const { data } = await apiClient.post(`/tasks/${id}/cancel`);
    return data.task;
  },
  async archiveTask(id) {
    const { data } = await apiClient.post(`/tasks/${id}/archive`);
    return data;
  },

  // Calendar
  async listEvents(params = {}) {
    const { data } = await apiClient.get("/calendar", { params });
    return data;
  },
  async createEvent(payload) {
    const { data } = await apiClient.post("/calendar", payload);
    return data.event;
  },
  async updateEvent(id, payload) {
    const { data } = await apiClient.put(`/calendar/${id}`, payload);
    return data.event;
  },
  async cancelEvent(id) {
    const { data } = await apiClient.post(`/calendar/${id}/cancel`);
    return data.event;
  },

  // Documents
  async listFolders() {
    const { data } = await apiClient.get("/documents/folders");
    return data.folders;
  },
  async createFolder(payload) {
    const { data } = await apiClient.post("/documents/folders", payload);
    return data.folder;
  },
  async listDocuments(params = {}) {
    const { data } = await apiClient.get("/documents", { params });
    return data;
  },
  async uploadDocument(formData, onProgress) {
    const { data } = await apiClient.post("/documents", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000,
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    });
    return data.document;
  },
  async updateDocument(id, payload) {
    const { data } = await apiClient.put(`/documents/${id}`, payload);
    return data.document;
  },
  async deleteDocument(id) {
    const { data } = await apiClient.delete(`/documents/${id}`);
    return data;
  },
  /** Authorized blob download (session cookie sent automatically). */
  async downloadDocument(id) {
    const res = await apiClient.get(`/documents/${id}/download`, { responseType: "blob", timeout: 120000 });
    return res.data;
  },
};
